import React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "antd";

const AddFileByDragRender = ({uploadBtnText}) => {
  const { t } = useTranslation(["upload", "common"]);
  return (
    <div id="UploadProps" className="add-file-container">
      <p>{t("Drag and drop files to the upload box.")}</p>
      <Button type="primary" size="large">
        {uploadBtnText ? t(uploadBtnText) : t("Choose File")}
      </Button>
    </div>
  );
};

export default AddFileByDragRender;
